import { render, staticRenderFns } from "./PrintAria.vue?vue&type=template&id=6affc5d3&"
import script from "./PrintAria.vue?vue&type=script&lang=js&"
export * from "./PrintAria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports